import axios from "axios";
import type {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  AxiosPromise,
} from "axios";
import { ElMessageBox } from "element-plus";
import store from "@user-center/store";

import { zhTranFn } from "@user-center/utils/zh.ts";
import { getToken, setToken } from "@user-center/utils/auth";
import { checkMallFetchUrl ,getMallAppToken,setMallAppToken,findDeepValText, getMallApiBaseUrl} from "@user-center/utils/qiankun";
import { setTransferTextMap } from "@user-center/utils/transferText";
import {
  reportMallApiRequestFailure,
  setMallEventLogContextProvider,
} from "@user-center/utils/mallEventLog";

import { alibabaProductTextTranslate } from "@user-center/api/mall";


import setUrl from "@user-center/utils/setUrl";
import router from "@user-center/router";
import $ from "jquery";
import { isTwLocale } from "@user-center/utils/i18n";
import {get,uniq,set,find} from "lodash-es";
import { requestHooks } from "quick-vue-components/index";
import { ElMessage, ElLoading } from "element-plus";
const fileFlow = false;
let flag: any;
let timer: any;
let loadingInstance: any;

setMallEventLogContextProvider(() => ({
  storeInfo: get(store, "state.app.storeInfoData", {}) || {},
  userInfo: get(store, "state.user", {}) || {},
  mallUserInfo: get(store, "state.user.mallUserInfo", {}) || {},
  userId:
    get(store, "state.user.mallUserInfo.id")
    || get(store, "state.user.mallUserInfo.userId")
    || get(store, "state.user.id"),
  mallApiUrl: getMallApiBaseUrl(),
  authToken: getMallAppToken() || getToken() || "",
}));

function parseRequestPayload(rawPayload: any) {
  if (!rawPayload) {
    return {};
  }

  if (typeof rawPayload === "string") {
    try {
      return JSON.parse(rawPayload);
    } catch (e) {
      return {};
    }
  }

  return rawPayload;
}

function removeMallJwtHeader(headers: Record<string, any> | undefined) {
  if (!headers || typeof headers !== "object") {
    return headers;
  }

  // user-center 里的 mall axios 请求同样不能透传站点 openaccessjwt。
  if (typeof (headers as any).delete === "function") {
    (headers as any).delete("openaccessjwt");
    (headers as any).delete("openAccessJwt");
  }

  Object.keys(headers).forEach((key) => {
    if (String(key || "").toLowerCase() === "openaccessjwt") {
      delete headers[key];
    }
  });

  return headers;
}
function shouldHideErrorTip(config?: AxiosRequestConfig<any>, response?: AxiosResponse<any, any>) {
  const url = String(
    get(config, "url", "")
    || get(response, "config.url", "")
    || "",
  );

  if (url.indexOf("hiddenErrTip=1") >= 0) {
    return true;
  }

  const payloadList = [
    get(config, "data"),
    get(config, "params"),
    get(response, "config.data"),
    get(response, "config.params"),
  ];

  return payloadList.some((payload) => {
    const parsedPayload = parseRequestPayload(payload);
    return Boolean(
      get(parsedPayload, "hideToastTip")
      || get(parsedPayload, "param.hideToastTip")
      || get(parsedPayload, "params.hideToastTip"),
    );
  });
}
function getTransferResults(rawTransferRes: any): any[] {
  const candidates = [
    get(rawTransferRes, "data.results", []),
    get(rawTransferRes, "data.data.results", []),
    get(rawTransferRes, "data.result", []),
    get(rawTransferRes, "results", []),
  ];
  const hit = candidates.find((item) => Array.isArray(item) && item.length);
  return Array.isArray(hit) ? hit : [];
}
function parseTranslateTexts(rawTransferRes: any): string[] {
  try {
    const transferRes = get(rawTransferRes, "data.result");
    const transferResults: any[] = getTransferResults(rawTransferRes);
    const transferData = get(rawTransferRes, "data.data");
    const transferListData = get(rawTransferRes, "data.list");
    const transferResultData = get(rawTransferRes, "data.resultList");
    if (transferResults.length) {
      return transferResults
        .slice()
        .sort((a: any, b: any) => Number(a?.index || 0) - Number(b?.index || 0))
        .map((item: any) => item?.translatedText || item?.sourceText || "");
    }
    if (Array.isArray(transferData)) return transferData;
    if (Array.isArray(transferListData)) return transferListData;
    if (Array.isArray(transferResultData)) return transferResultData;
    if (typeof transferRes === "string") return String(transferRes).split("\n");
  } catch (e) {
    console.log(e);
  }
  return [];
}
async function safeTranslateBatch(payload: any, timeoutMs = 3000): Promise<any | null> {
  try {
    const timeoutPromise = new Promise<null>((resolve) => {
      setTimeout(() => resolve(null), timeoutMs);
    });
    const translatePromise = alibabaProductTextTranslate(payload).catch(() => null);
    return await Promise.race([translatePromise, timeoutPromise]);
  } catch (e) {
    console.log(e);
    return null;
  }
}
function closeLoading() {
  $("#loading-tip").remove();
  loadingInstance && loadingInstance.close();
  loadingInstance = null;
}
requestHooks.requestUse =  (config: AxiosRequestConfig<any>) => {
  (config as any).__requestStartedAt = Date.now();
  config.baseURL = config.baseURL || setUrl();

  let isMallUrl=checkMallFetchUrl(config.url)

  // mall 请求只保留 authorization，统一剔除 openaccessjwt。
  if (isMallUrl) {
    config.headers = config.headers || {};
    removeMallJwtHeader(config.headers as Record<string, any>);
  }

  if (store.getters.token || getToken()) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    // config.headers["authorization"] = getToken();
    if(isMallUrl){
      // mall 翻译接口可能需要商城 token；缺失则回退主站 token
      config.headers.authorization = getMallAppToken() || getToken() || "";
    }else{
      const token: string | null = getToken();
      if (typeof config.headers != "undefined") {
        if (typeof token === "string") {
          config.headers.authorization = token;
        } else {
          config.headers.authorization = "";
        }
      }
    }
  
   
  }
  return config;
};

(requestHooks as any).responseUse = async (response: AxiosResponse<any, any>) => {
 
  let isMallUrl=checkMallFetchUrl(response.request.responseURL)
  if (
     get(response, "request.responseURL") &&
     get(response, "request.responseURL")
      .indexOf("transferlocate=true") >= 0&&
      isTwLocale()
  ) {
    try {
      const resDataStr = zhTranFn(JSON.stringify(response.data), "t");
      response.data = JSON.parse(resDataStr);
    } catch (e) {
      console.log(e);
    }
  }
  // const res = {
  //   ...resData,
  //   token: response.headers.authorization,
  //   isRoot: response.headers.is_root,
  // };

  const res = response;


  try{
    const rawConfigData = get(response, "config.data", "");
    const configDataStr =
      typeof rawConfigData === "string"
        ? rawConfigData
        : JSON.stringify(rawConfigData || {});
    if (response.data && configDataStr.indexOf('___transferConfig')>=0 ) {
      let transferKeysConfig = [];
      let orgData={}
      try {
        orgData =
          typeof rawConfigData === "string"
            ? JSON.parse(rawConfigData || "{}")
            : (rawConfigData || {});
        transferKeysConfig = JSON.parse(get(orgData, "___transferConfig.transferKeysConfig"));
      } catch (e) {}
      if (transferKeysConfig.length) {
        const targetLanguage = String(get(orgData,'___transferConfig.language') || "")
        let transferList = [];
        findDeepValText(response.data,transferKeysConfig,transferList);

        transferList = uniq(
          transferList
            .map((item: any) => String(item ?? "").trim())
            .filter((item: string) => !!item)
        );
        if(transferList.length&&targetLanguage.indexOf('zh')<0){
          const transfersMap: Record<string, string> = {};
          const formatType = get(orgData,'___transferConfig.transferType')||"text";
          //超过88条重新调用接口
          for (let i = 0; i < transferList.length; i += 100) {
            const chunk = transferList.slice(i, i + 100);
            const resTransferLang = await safeTranslateBatch({
              "param":{
                "sourceTextList": chunk.join("\n"),
                "sourceLanguage":"zh",
                "targetLanguage":targetLanguage,
                "formatType": formatType
              }
            });
            if (!resTransferLang || resTransferLang?.success === false) {
              chunk.forEach((k) => {
                transfersMap[k] = k;
              });
              continue;
            }
            const transfers = parseTranslateTexts(resTransferLang);
            chunk.forEach((k, idx) => {
              transfersMap[k] = transfers[idx] || k;
            });
          }
          if (Object.keys(transfersMap).length) {
            setTransferTextMap(targetLanguage, transfersMap);
            if(get(orgData,'___transferConfig.setPath')=='null'){
              response.data.transfersMap=transfersMap;
            }else{
              set(response.data,get(orgData,'___transferConfig.setPath')||'data.transfersMap',transfersMap);
            }
          }
        }
        
      }
    }
  }catch(e){
    console.log(e)
  }

  if (response.headers.authorization) {
    if(!isMallUrl){

      
      setToken(response.headers.authorization);

      store.commit("user/SET_TOKEN", response.headers.authorization);
    }else if(isMallUrl){
      setMallAppToken(response.headers.authorization);
    }
  }
  const isDownloadFileSuccess =
    response.request.responseType == "arraybuffer" && response.status == 200; // 增加下载文件判断

  if (
    !isDownloadFileSuccess
    && response.data
    && (
      (typeof response.data.success === "boolean" && !response.data.success)
      || (typeof response.data.result === "boolean" && !response.data.result)
      || (
        response.data.status
        && String(response.data.status) !== "200"
        && response.data.status !== "SUCCESS"
        && response.data.status !== "success"
      )
    )
  ) {
    reportMallApiRequestFailure({
      url: response.request?.responseURL || response.config?.url,
      method: response.config?.method,
      status: response.status || response.data.status || response.data.code,
      durationMs: Date.now() - Number((response.config as any)?.__requestStartedAt || Date.now()),
      stage: "business",
      message: response.data.msg || response.data.message || response.data,
    });
  }

  // if the custom code is not 20000, it is judged as an error.
  // if (
  //   !res.credentials && // 腾讯云cos
  //   res.code !== 20000 &&
  //   res.status != "ADMIN_AUTH_S_001" &&
  //   res.status != "AUTH_S_001" &&
  //   res.success != true &&
  //   !isDownloadFileSuccess &&
  //   !res.accessKeyId //阿里云oss
  // ) {
  //   // Message({
  //   //   message: res.message || "Error",
  //   //   type: "error",
  //   //   duration: 5 * 1000
  //   // });

  //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
  //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //     // to re-login
  //     ElMessageBox.confirm(
  //       "You have been logged out, you can cancel to stay on this page, or login again",
  //       "Confirm logout",
  //       {
  //         confirmButtonText: "Re-Login",
  //         cancelButtonText: "Cancel",
  //         type: "warning",
  //       }
  //     ).then(() => {
  //       store.dispatch("user/resetToken").then(() => {
  //         location.reload();
  //       });
  //     });
  //   }
  //   debugger;
  //   return Promise.reject({
  //     ...(res || {}),
  //     message: res.message || res.msg || "Error",
  //   });
  // } else {
  return isDownloadFileSuccess ? response : res;
  // }
};

requestHooks.responseError = (
  error: AxiosError<any, any>
): AxiosError<any, any> => {
  reportMallApiRequestFailure({
    url: error?.config?.url || error?.request?.responseURL || error?.request?.url,
    method: error?.config?.method,
    status: error?.response?.status || (error as any)?.status,
    durationMs: Date.now() - Number((error?.config as any)?.__requestStartedAt || Date.now()),
    stage: error?.response ? "http" : "network",
    message: error?.response?.data || error?.message || error,
    ext: {
      axios_code: (error as any)?.code,
    },
  });
  try {
    error.message = error.response?.data.message; // 判断后台是否有错误信息返回;
  } catch (e) {
    console.log("无法从response.data中拿到错误信息");
  }
  if (error.response && error.response.status == 401) {
    // 假如401 退出账号
    error.message = "用户信息超时,请重新登录";
    store.dispatch("user/resetToken").then(() => {
      router.push("/login");
    });
  }
  if (error.response && error.response.status == 404 && !shouldHideErrorTip(error.config, error.response)) {
    ElMessage.error("接口调用失败 404");
  }
  return error;
};
// create an axios instance
const service: AxiosInstance = axios.create({
  baseURL: setUrl(),
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5 * 60 * 1000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config: AxiosRequestConfig<any>) => {
    // do something before request is sent
    config = requestHooks.requestUse(config);
    return config;
  },
  (error: AxiosError<any, any>) => {
    error = requestHooks.requestError(error);
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response: AxiosResponse<any, any>) => {
    // if (!response.data.success || response.data.result === false) {
    //   ElMessage.error(response.data.msg);
    //   return Promise.reject(response.data.msg);
    // } else {
    //   return requestHooks.responseUse(response);
    // }
    return requestHooks.responseUse(response);
  },
  (error: AxiosError<any, any>) => {
    error = requestHooks.responseError(error);
    return Promise.reject(error);
  }
);

// export default service;
const request = async (
  AxiosRequestConfig: AxiosRequestConfig<any>,
  Options: any = {
    returnAll: false,
    loading: false,
  }
) => {
  if (Options.loading) {
    loadingInstance = ElLoading.service({
      fullscreen: true,
      background: "rgba(0, 0, 0, 0.7)",
      // customClass: "wms-loading",
    });
  }
  return new Promise((resolve, reject) => {
    service(AxiosRequestConfig)
      .then((response: any) => {
        if (Options.returnAll) {
          resolve(response);
        } else if (
          !response.data.list &&
          !response.data.accessKeyId &&
          !shouldHideErrorTip(response.config, response) &&
          ((typeof response.data.success === 'boolean' && !response.data.success) || (typeof response.data.result === 'boolean' && !response.data.result))
        ) {
          ElMessage.error(response.data.msg || response.data.message);
          reject(response.data.msg || response.data.message);
        } else {
          const res = {
            ...response.data,
            token: response.headers.authorization,
            isRoot: response.headers.is_root,
          };
          resolve(res);
        }
        closeLoading();
      })
      .catch((err: any) => {
        reject(new Error(err));
        closeLoading();
      });
  }) as AxiosPromise<unknown>;
};
export default request;
